export function displayFormattedAddress(address, value1, value2) {
  const formattedAddress = `0x${address.slice(2, value1)}...${address.slice(
    -value2
  )}`;
  return formattedAddress;
}
